import React, { Component } from "react";
import { connect } from "react-redux";
import logo from "../../static/images/rewardzlogo.svg";
import { withRouter } from "react-router-dom";
import * as LoginAction from "./Actions/LoginActions";
import { showEventModalAction, hideEventModalAction } from "../../Common/CommonStore/CommonActions";
import crypto from "crypto";
import config from "config";

class Login extends Component {
  constructor( props ) {
    super( props );
    this.state = { 
      userName: null,
      password: null,
      validate: false,
      showLoader: false
    };
    this.handleLoginSubmit = this.handleLoginSubmit.bind( this );
  }

  toggleValidating( validate ) {
    this.setState( { validate } );
  }

  componentDidUpdate( prevProps ) {
    if( this.props.loginError && this.props.loginMessage && !prevProps.loginError ) {
      this.setState( { showLoader: false }, () => {
        this.props.showEventModal( {
          showEventModal: true,
          eventModalTitle: "Error",
          eventModalBody: this.props.loginMessage,
          showEventModalButtonOne: true,
          showEventModalButtonTwo: false,
          buttonOneEventModalHandler: () => { this.props.hideEventModal(); this.props.loginErrorClear(); },
          buttonTwoEventModalHandler: null,
          buttonOneEventModalName: "OK",
          buttonTwoEventModalName: "",
          graphContent: null,
          graphTitle: "",
          showGraph: false,
          graphName: "",
          graphId: ""
        } );
      } );
    }
  }

  handleInputChange = ( e ) => {
    e.preventDefault();
    this.setState( {
      [e.target.name]: e.target.value
    } );
    console.log(e.target.value)
  }

  handleLoginSubmit = async( e ) => {
    e.preventDefault();
    this.toggleValidating( true );
    const { userName, password } = this.state;
    console.log(userName, password, this.state)
    // if( userName && password ) {
      let cipher = crypto.createCipher( "aes-128-cbc", config.SECRET_KEY );
      let myStr = cipher.update( this.state.password, "utf8", "hex" ) + cipher.final( "hex" );
       
      let apiPayload = {
        username: this.state.userName,
        password: myStr
      };
      this.setState( { 
        ...this.state,
        showLoader: true
       }, () => {
        this.props.loginRequest( apiPayload );
       } )  
    // } 
  }

  render() { 
    const isThankAbundantlyServer = window.location.hostname === "analytics.thankabundantly.com"
    document.title = isThankAbundantlyServer ? "Abundantly" : "Rewardz";
    return ( 
      isThankAbundantlyServer ? 
      <div class="ta-login-wraper">
        <div class="ta-login-container">
          <div class="ta-logo-shape">
            <div class="ta-top-left-shape"></div>
            <div class="ta-bottom-right-shape"></div>
          </div>

          <div class="ta-login-form">
            <div class="ta-logo-svg">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2812.5 750">
                <defs></defs>
                <g id="a"></g>
                <g id="b">
                  <g>
                    <g>
                      <path
                        class="c"
                        d="M221.98,575.07c-4.92,33.12-14.77,51.02-44.31,51.02-22.38,0-38.49-12.08-42.52-37.15-12.98,25.51-34.91,38.94-59.53,38.94-31.78,0-52.36-17.9-52.36-47.44,0-29.54,20.14-46.54,59.97-59.52l50.58-15.66v-20.59c0-34.01-16.11-50.58-46.1-50.58-15.22,0-29.09,3.58-37.15,8.06,2.69,18.8,21.93,21.93,21.93,40.28,0,14.77-12.53,27.3-29.54,27.3-17.9,0-29.54-13.88-29.54-33.57,0-39.38,46.55-72.06,93.09-72.06,43.86,0,73.85,22.38,73.85,73.4v95.78c0,12.53,3.58,17.9,11.64,17.9,7.61,0,12.09-5.82,16.11-19.7l13.87,3.58Zm-88.17-7.61v-41.17l-29.54,10.74c-22.38,8.06-34.01,15.66-34.01,31.78,0,14.77,9.85,23.72,25.06,23.72,12.98,0,26.85-8.06,38.49-25.07Z"
                      ></path>
                      <path
                        class="c"
                        d="M442.62,510.62c0,72.95-36.25,117.26-98.91,117.26-28.2,0-50.13-10.29-64.9-26.41l-13.43,21.48h-20.14v-255.56c0-23.72-5.37-29.09-28.64-29.09v-14.32l61.76-20.14h13.43v143.22c13.87-25.06,37.15-42.97,67.13-42.97,51.02,0,83.69,41.18,83.69,106.52Zm-51.92,13.43c0-48.78-19.25-78.77-51.92-78.77-17.9,0-33.12,6.26-46.99,20.14v78.77c0,40.28,16.56,60.87,46.1,60.87,34.46,0,52.81-29.99,52.81-81.01Z"
                      ></path>
                      <path
                        class="c"
                        d="M660.58,565.67c0,27.75,6.71,32.67,34.01,32.67v15.22l-74.29,10.74-6.27-4.92v-34.46c-14.77,28.19-34.01,42.97-63.55,42.97-38.49,0-63.11-25.06-63.11-76.09v-100.7c0-17.9-6.27-24.17-23.72-26.86v-14.77h70.27v129.34c0,35.81,12.53,47.89,35.8,47.89,16.11,0,30.43-6.27,44.31-20.14v-115.47c0-19.69-5.37-24.62-29.99-26.86v-14.77h76.53v156.2Z"
                      ></path>
                      <path
                        class="c"
                        d="M921.51,575.52c0,23.72,4.48,29.09,27.3,31.33v14.77h-99.36v-14.77c21.48-2.24,25.51-7.61,25.51-31.33v-85.49c0-30.43-12.53-44.75-37.6-44.75-16.56,0-31.33,5.82-44.76,19.69v110.55c0,23.72,4.48,29.09,29.09,31.33v14.77h-105.18v-14.77c24.17-2.24,29.54-7.61,29.54-31.33v-106.07c0-25.06-5.37-31.33-29.54-31.33v-13.43l61.32-17.9h14.77v40.28c13.88-26.86,36.25-42.97,65.79-42.97,40.73,0,63.11,25.51,63.11,76.08v95.33Z"
                      ></path>
                      <path
                        class="c"
                        d="M1201.68,606.85v14.77h-68.92l-4.92-4.03-3.58-32.67c-15.22,27.3-36.7,42.97-67.58,42.97-50.13,0-83.25-41.18-83.25-106.52,0-70.71,36.25-117.26,98.91-117.26,19.69,0,37.6,4.92,51.92,14.32v-51.02c0-23.72-7.16-29.09-38.94-29.09v-14.32l72.06-20.14h13.43v264.51c0,29.54,5.37,36.25,30.88,38.49Zm-77.43-40.73v-78.32c0-41.62-16.11-60.87-44.76-60.87-34.91,0-54.15,31.33-54.15,81.46,0,48.79,19.24,78.32,51.92,78.32,17.01,0,33.12-6.27,46.99-20.59Z"
                      ></path>
                      <path
                        class="c"
                        d="M1430.83,575.07c-4.92,33.12-14.77,51.02-44.31,51.02-22.38,0-38.49-12.08-42.52-37.15-12.98,25.51-34.91,38.94-59.53,38.94-31.78,0-52.36-17.9-52.36-47.44,0-29.54,20.14-46.54,59.97-59.52l50.58-15.66v-20.59c0-34.01-16.11-50.58-46.1-50.58-15.22,0-29.09,3.58-37.15,8.06,2.69,18.8,21.93,21.93,21.93,40.28,0,14.77-12.53,27.3-29.54,27.3-17.9,0-29.54-13.88-29.54-33.57,0-39.38,46.55-72.06,93.09-72.06,43.86,0,73.85,22.38,73.85,73.4v95.78c0,12.53,3.58,17.9,11.63,17.9,7.61,0,12.09-5.82,16.11-19.7l13.88,3.58Zm-88.17-7.61v-41.17l-29.54,10.74c-22.38,8.06-34.01,15.66-34.01,31.78,0,14.77,9.85,23.72,25.06,23.72,12.98,0,26.86-8.06,38.49-25.07Z"
                      ></path>
                      <path
                        class="c"
                        d="M1645.21,575.52c0,23.72,4.47,29.09,27.3,31.33v14.77h-99.36v-14.77c21.48-2.24,25.51-7.61,25.51-31.33v-85.49c0-30.43-12.53-44.75-37.6-44.75-16.56,0-31.33,5.82-44.75,19.69v110.55c0,23.72,4.47,29.09,29.09,31.33v14.77h-105.18v-14.77c24.17-2.24,29.54-7.61,29.54-31.33v-106.07c0-25.06-5.37-31.33-29.54-31.33v-13.43l61.32-17.9h14.77v40.28c13.87-26.86,36.25-42.97,65.79-42.97,40.73,0,63.11,25.51,63.11,76.08v95.33Z"
                      ></path>
                      <path
                        class="c"
                        d="M1843.48,580.89c-17.01,29.54-34.01,45.2-63.55,45.2-35.36,0-59.08-22.82-59.08-64.89v-111.89h-38.04v-21.93c33.57-4.48,54.15-24.17,60.87-55.5h23.72v37.6h62.66v39.83h-62.66v99.36c0,25.51,11.19,37.6,30.43,37.6,13.88,0,25.06-5.82,34.91-15.22l10.74,9.85Z"
                      ></path>
                      <path
                        class="c"
                        d="M1967.89,606.85v14.77h-110.99v-14.77c26.41-2.24,32.23-5.82,32.23-39.83v-199.61c0-23.72-5.37-29.09-28.64-29.09v-14.32l61.76-20.14h13.43v263.17c0,34.01,8.5,37.6,32.22,39.83Z"
                      ></path>
                      <path
                        class="c"
                        d="M2123.64,409.47h76.53v14.77c-12.98,2.24-18.35,8.95-30.43,38.49l-68.03,166.04c-25.51,62.21-52.81,89.07-89.96,89.07-25.96,0-45.2-14.77-45.2-35.81,0-17.45,10.74-26.85,26.41-26.85,21.48,0,21.93,21.03,42.07,34.91,18.8-11.19,31.33-37.15,46.99-74.74l-65.79-147.69c-14.77-33.12-21.03-41.62-34.01-43.42v-14.77h105.62v14.77c-17.9,.9-26.86,6.72-26.86,18.8,0,3.58,.9,7.61,2.69,12.53l42.52,101.6,39.83-96.68c2.23-6.27,4.03-11.64,4.03-16.56,0-12.09-9.85-19.25-26.41-19.7v-14.77Z"
                      ></path>
                    </g>
                    <g>
                      <path
                        class="d"
                        d="M2385.97,364.49h-14.44c-52.67,0-95.37,42.7-95.37,95.37h0c0,52.67,42.7,95.37,95.37,95.37h0c52.67,0,95.37-42.7,95.37-95.37v-14.61h-80.94v-80.76Z"
                      ></path>
                      <rect
                        class="f"
                        x="2385.99"
                        y="364.49"
                        width="80.95"
                        height="80.76"
                      ></rect>
                      <path
                        class="e"
                        d="M2499.14,218.94h0c-62.49,0-113.16,50.66-113.16,113.16v32.4h80.95v80.76h32.21c62.49,0,113.16-50.66,113.16-113.15h0c0-62.49-50.66-113.16-113.15-113.16Z"
                      ></path>
                      <path
                        class="g"
                        d="M2543.94,129.33h0c-87.24,0-157.96,70.72-157.96,157.96v44.8c0-62.49,50.66-113.16,113.16-113.16h0c62.49,0,113.16,50.66,113.15,113.16h0c0,62.49-50.66,113.16-113.16,113.16h44.8c87.24,0,157.96-70.72,157.96-157.96h0c0-87.24-70.72-157.96-157.96-157.96Z"
                      ></path>
                      <path
                        class="h"
                        d="M2592.54,32.16h0c-114.07,0-206.55,92.47-206.55,206.55v48.59c0-87.24,70.72-157.96,157.96-157.96h0c87.24,0,157.96,70.72,157.96,157.96h0c0,87.24-70.72,157.96-157.96,157.96h48.59c114.07,0,206.55-92.47,206.55-206.55h0c0-114.07-92.47-206.55-206.55-206.55Z"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <form onSubmit={ this.handleLoginSubmit }>
                <div className="form-group">                                    
                  <input
                    type="text"
                    name="userName"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="Username"
                    value={this.state.userName || ""}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="form-group">                                   
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    value={this.state.password || ""}
                    onChange={this.handleInputChange}
                  />
                </div>      
                <div className={`logInbtn ${ this.state.showLoader ? "btn-loader": "" }`}>                         
                  <button type="submit" className="btn btn-primary" onClick={this.handleLoginSubmit} >Login--</button>
                </div>  
              </form>
          </div>
        </div>
      </div>
      :
      <div className="login-wraper">
        <div className="contaienr-fluid">
          <div className="login-container d-flex">
            <div className="login-icon">
              <img src={ logo } title="logo"/>
            </div>
            <div className="loginform d-flex">
              <h4>Login</h4>
              <form onSubmit={ this.handleLoginSubmit }>
                <div className="form-group">                                    
                  <input
                    type="text"
                    name="userName"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="Username"
                    value={this.state.userName || ""}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="form-group">                                   
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    value={this.state.password || ""}
                    onChange={this.handleInputChange}
                  />
                </div>      
                <div className={`logInbtn ${ this.state.showLoader ? "btn-loader": "" }`}>                         
                  <button type="submit" className="btn btn-primary" onClick={this.handleLoginSubmit} >Login</button>
                </div>  
              </form>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = ( state ) => {
  return {
    loginError: state.Login.loginError,
    loginMessage: state.Login.loginMessage,
    showEventModalFlag: state.Common.showEventModal
  };
};

const mapDispatchToProps = ( dispatch ) => {
  return {
    loginRequest: ( payload ) => dispatch( LoginAction.loginRequestAction( payload ) ),
    showEventModal: ( payload ) => dispatch( showEventModalAction( payload ) ),
    hideEventModal: ( ) => dispatch( hideEventModalAction() ),
    loginErrorClear: () => dispatch( LoginAction.loginErrorClearAction() )

  };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( Login ) );